import { SimpleCard } from "./DataCard";
import { BarChart } from "./BarChart";

export const ComparisonSection = () => {
  return (
    <section className="section-card mt-5 sm:mt-7">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1.5 sm:gap-2 mb-5 sm:mb-6">
        <h2 className="font-display text-lg sm:text-xl font-semibold tracking-tight text-foreground">
          Normal month versus December
        </h2>
        <p className="text-[11px] sm:text-xs text-muted-foreground">
          How inbox competition and user focus change in Q4
        </p>
      </div>

      <div className="grid lg:grid-cols-[1.3fr_1fr] gap-3 sm:gap-4">
        <SimpleCard title="Typical month pattern">
          <p className="text-xs text-muted-foreground leading-relaxed mb-3">
            In regular months subscribers check email around the same times on workdays.
            Inboxes are still busy but more predictable.
          </p>
          
          <ul className="list-none space-y-1.5 mb-4">
            {[
              "Steady open and click rates across weeks",
              "Clear best times during normal work hours",
              "Less clustering of competing campaigns"
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-xs text-muted-foreground">
                <span className="w-1 h-1 rounded-full bg-primary mt-1.5 shrink-0" />
                {item}
              </li>
            ))}
          </ul>

          <div className="border-t border-border pt-3 mt-3">
            <p className="text-[10px] sm:text-[11px] text-muted-foreground">
              Benchmarks show average open rates around 25–40% and click rates
              around 3% depending on industry and email type.
            </p>
          </div>
        </SimpleCard>

        <SimpleCard title="December pattern">
          <p className="text-xs text-muted-foreground leading-relaxed mb-4">
            In December subscribers receive many more offers in a short period.
            Personal and travel-related messages also increase.
          </p>

          <div className="space-y-3">
            <div>
              <div className="text-[10px] sm:text-[11px] text-muted-foreground mb-1.5 font-medium">Regular week</div>
              <BarChart percentage={68} />
            </div>

            <div>
              <div className="text-[10px] sm:text-[11px] text-muted-foreground mb-1.5 font-medium">Peak December week</div>
              <BarChart percentage={100} variant="red" />
            </div>
          </div>

          <ul className="list-none space-y-1.5 mt-4">
            {[
              "Campaigns delivered but never seen in main view",
              "High-intent subscribers may postpone action",
              "Replies more likely once routines resume"
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-2 text-xs text-muted-foreground">
                <span className="w-1 h-1 rounded-full bg-destructive mt-1.5 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </SimpleCard>
      </div>
    </section>
  );
};